export const environment = {
  production: true,
  baseUrl: 'https://dev-api.bookingagency.com.co',
  appName: 'BookingAgency',
  travelfestAgencyId: 1,
};
